import { EEnsoleillement } from '../SANDRE/ensoleillement';
import { EMeteo } from '../SANDRE/meteo';
import { SituationHydrologie6sem } from '../SANDRE/situation-hydro-6sem';
import { VisibiliteFond } from '../SANDRE/visibilite-fond';
import { Odeur } from '../SANDRE/odeur';
import { Teinte } from '../SANDRE/teinte';
import { Hydrologie } from '../SANDRE/hydrologie';
import { VariationDebit } from '../SANDRE/variation-debit';
import { Limpidite } from '../SANDRE/limpidite';
import { ESecuriteMiseALEau } from './securite-mise-eau';

export class ConditionPrelevement {
    id: number
    interventionId: number; // IndexedDB
    Meteo: EMeteo;
    Ensoleillement: EEnsoleillement;
    Hydrologie: Hydrologie;
    VariationDebit: VariationDebit;
    SituationHydro6Sem: SituationHydrologie6sem;
    Limpidite: Limpidite;
    Visibilite: VisibiliteFond;
    Odeur: Odeur;
    Teinte: Teinte;
    SecuriteMiseALeau: ESecuriteMiseALEau;
    NatureDanger: string;

    static mapFromJSON(json): ConditionPrelevement {
        const c = new ConditionPrelevement();

        c.Meteo = json.meteo;
        c.Ensoleillement = json.ensoleillement;
        c.Hydrologie = json.hydrologie;
        c.VariationDebit = json.variationDebit;
        c.SituationHydro6Sem = json.situationHydro6Sem;
        c.Limpidite = json.limpidite;
        c.Visibilite = json.visibilite;
        c.Odeur = json.odeur;
        c.Meteo = json.meteo;
        c.Teinte = json.teinte;
        c.SecuriteMiseALeau = json.securiteMiseALeau;
        c.NatureDanger = json.natureDanger;

        return c;
    }
}
